import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from './authContext';
import { LoadingSpinner } from '../components/LoadingSpinner';
export const ProtectedRoute = ({ children }) => {
    const { isLoading, isAuthenticated } = useAuth();
    if (isLoading) {
        return _jsx(LoadingSpinner, {});
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
//# sourceMappingURL=ProtectedRoute.js.map